import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "main-content-container overflow-hidden" }
const _hoisted_2 = { class: "px-2 px-sm-5 position-relative mb-4" }
const _hoisted_3 = { class: "row" }
const _hoisted_4 = { class: "col-xxl-4 col-lg-4" }
const _hoisted_5 = { class: "col-xxl-8 col-lg-8" }
const _hoisted_6 = { class: "row" }
const _hoisted_7 = { class: "col-lg-8 col-xxl-9" }
const _hoisted_8 = { class: "col-lg-4 col-xxl-3" }
const _hoisted_9 = { class: "row" }
const _hoisted_10 = { class: "col-xxl-8 col-lg-7" }
const _hoisted_11 = { class: "col-xxl-4 col-lg-5" }
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-xxl-3 col-sm-6 order-2 order-xxl-1" }
const _hoisted_14 = { class: "col-xxl-6 col-lg-12 order-1 order-xxl-2" }
const _hoisted_15 = { class: "col-xxl-3 col-sm-6 order-3 order-xxl-3" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ManageYourNFT = _resolveComponent("ManageYourNFT")!
  const _component_NFTSlideItem = _resolveComponent("NFTSlideItem")!
  const _component_EthereumRateTab = _resolveComponent("EthereumRateTab")!
  const _component_ActiveAuctions = _resolveComponent("ActiveAuctions")!
  const _component_FeaturedNFTArtworks = _resolveComponent("FeaturedNFTArtworks")!
  const _component_NewMobileApp = _resolveComponent("NewMobileApp")!
  const _component_MostPopularSellers = _resolveComponent("MostPopularSellers")!
  const _component_WorldwideTopCreators = _resolveComponent("WorldwideTopCreators")!
  const _component_TopCollections = _resolveComponent("TopCollections")!
  const _component_TopNFTs = _resolveComponent("TopNFTs")!
  const _component_HistoryOfBids = _resolveComponent("HistoryOfBids")!
  const _component_CreateNFT = _resolveComponent("CreateNFT")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_component_ManageYourNFT),
      _createElementVNode("div", _hoisted_2, [
        _createVNode(_component_NFTSlideItem)
      ]),
      _createElementVNode("div", _hoisted_3, [
        _createElementVNode("div", _hoisted_4, [
          _createVNode(_component_EthereumRateTab)
        ]),
        _createElementVNode("div", _hoisted_5, [
          _createVNode(_component_ActiveAuctions)
        ])
      ]),
      _createElementVNode("div", _hoisted_6, [
        _createElementVNode("div", _hoisted_7, [
          _createVNode(_component_FeaturedNFTArtworks)
        ]),
        _createElementVNode("div", _hoisted_8, [
          _createVNode(_component_NewMobileApp)
        ])
      ]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("div", _hoisted_10, [
          _createVNode(_component_MostPopularSellers)
        ]),
        _createElementVNode("div", _hoisted_11, [
          _createVNode(_component_WorldwideTopCreators)
        ])
      ]),
      _createElementVNode("div", _hoisted_12, [
        _createElementVNode("div", _hoisted_13, [
          _createVNode(_component_TopCollections)
        ]),
        _createElementVNode("div", _hoisted_14, [
          _createVNode(_component_TopNFTs)
        ]),
        _createElementVNode("div", _hoisted_15, [
          _createVNode(_component_HistoryOfBids)
        ])
      ])
    ]),
    _createVNode(_component_CreateNFT)
  ], 64))
}